const filterSearch = document.querySelector('.filter-search');

if (filterSearch) {
  const searchForNewSuggestions = (search) => {
    const dropdown = filterSearch.querySelector('.filter-search__dropdown');
    axios
      .get(localData.siteURL, {
        params: {
          action: 'getNewSuggestions',
          id: localData.id,
          lang: localData.lang,
          period: new URLSearchParams(window.location.search).get('period') || 'all',
          'search-term': search || '',
          'year-period' : new URLSearchParams(window.location.search).get('year-period') || '',
        },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          dropdown.innerHTML = response.data.data.message;
        } else {
          console.error('error fetching new objects');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  attachEvent('#filter-search', 'click', (ev) => {
    filterSearch.classList.add('is-active');
  });
  const searchInput = filterSearch.querySelector('.filter-search__input-field');
  searchInput.addEventListener('keyup',(e) => {
    const debouncedSearch = debounce(() => searchForNewSuggestions(e.target.value), 50);
    debouncedSearch();
  });
// *******************************************************************************
// 2.0 - Close dropdown
// *******************************************************************************

  attachEvent('.filter-search__reset-button', 'click', (ev) => {
    filterSearch.classList.remove('is-active');
  });

  // Close Modal When Escape Key Press
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' || event.key === 'Enter') {
      filterSearch.classList.remove('is-active');
    }
  });

  // Close Inquiry Modal When Click Out
  document.addEventListener('click', (evt) => {
    let targetElement = evt.target; // clicked element
    do {
      if (targetElement === filterSearch) {
        return;
      }
      targetElement = targetElement.parentNode;
    } while (targetElement);
      filterSearch.classList.remove('is-active');
  });
}

